module.exports = __webpack_public_path__ + "static/media/NotoSans-ExtraBold.e9a239b8.eot";